import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

import { FlexDiv } from "./FlexDiv";

interface ElementsContainerProps {
  row?: boolean;
}

// Handle layout style
export const ElementsContainer = styled(FlexDiv)<ElementsContainerProps>`
  gap: ${Variables.space100};
  flex-direction: ${(props) => (props.row ? "row" : "column")};
  ${(props) => (props.row ? "align-items: center" : "")};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : "start"};
`;
